import React from 'react';

import Typography from '@material-ui/core/Typography';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import Header from './Header';

import AAA_profile from './img/ahmed_abdelali_2.jpeg';
import HM_profile from './img/hamdy_mubarak_3.jpeg';
import ND_profile from './img/NadirDurrani_square.JPG';
import FD_profile from './img/FahimDalvi_square.jpg';
import Kanari_profile from './img/kanari.png';

import './About.css';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#f5f5f5',
      light: '#ffffff',
      dark: '#c2c2c2'
    },
    secondary: {
      main: '#29b6f6',
      light: '#73e8ff',
      dark: '#0086c3'
    },
  },
  typography: {
    useNextVariants: true,
  },
});

class About extends React.Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <div className="App">
          <Header />
          <div className="Content">
            <Typography variant="h6" style={{marginTop: '30px'}}>
              NatiQ (Arabic Text-to-Speech) and its API are brought to you by the <a href="https://alt.qcri.org">Arabic Language Technologies</a> team at the <a href="http://qcri.org">Qatar Computing Research Institute</a>.
            </Typography>
            <Typography variant="h5" style={{marginTop: '30px'}}>
              Team
            </Typography>
            <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-evenly'}}>
              <div className="author">
                <img src={AAA_profile} alt="Ahmed Abdelali" />
                <span className="author-name"> Ahmed Abdelali </span>
                <span className="author-position"> Principal Software Engineer </span>
                <span className="author-org"> Qatar Computing Research Institute </span>
              </div>
              <div className="author">
                <img src={HM_profile} alt="Hamdy Mubarak" />
                <span className="author-name"> Hamdy Mubarak </span>
                <span className="author-position"> Principal Software Engineer </span>
                <span className="author-org"> Qatar Computing Research Institute </span>
              </div>
              <div className="author">
                <img src={ND_profile} alt="Nadir Durrani" />
                <span className="author-name"> Nadir Durrani </span>
                <span className="author-position"> Senior Scientist </span>
                <span className="author-org"> Qatar Computing Research Institute </span>
              </div>
              <div className="author">
                <img src={FD_profile} alt="Fahim Dalvi" />
                <span className="author-name"> Fahim Dalvi </span>
                <span className="author-position"> Software Engineer </span>
                <span className="author-org"> Qatar Computing Research Institute </span>
              </div>
            </div>
            <Typography variant="h5" style={{marginTop: '30px'}}>
              Partners
            </Typography>
            <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-evenly'}}>
              <div class="author">
                <img src={Kanari_profile} alt="" />
              </div>
            </div>
            <Typography variant="body2" style={{marginTop: '30px'}}>
                NatiQ is a limited feature offering for demonstration, evaluation and testing purposes only.
                <br/>
                For commercial or non-research use, please contact <a href="https://kanari.ai/">Kanari.AI</a>.
            </Typography>
            <Typography variant="overline" style={{marginTop: '30px'}}>
              © 2021-{new Date().getFullYear()} Qatar Computing Research Institute, Hamad Bin Khalifa University
            </Typography>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default About;
